import { useState } from "react";
import { apiFetch } from "@/lib/api/client";
import type { NoticeType } from "@/types";
import type { AgentInstallCommand, PanelDialogState } from "@/modules/panel/types";

type Notify = (text: string, type?: NoticeType) => void;

export function usePanelDialogs(notify: Notify): PanelDialogState {
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [settingsProxyUrl, setSettingsProxyUrl] = useState("");
  const [settingsSaving, setSettingsSaving] = useState(false);
  const [agentInstallCommand, setAgentInstallCommand] = useState<AgentInstallCommand | null>(null);

  const savePanelSettings = async () => {
    setSettingsSaving(true);
    try {
      const response = await apiFetch("/api/settings", {
        method: "PUT",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({ aiProxyUrl: settingsProxyUrl.trim() }),
      });
      const payload = await response.json();
      if (!response.ok || !payload.ok) throw new Error(payload.error || `HTTP ${response.status}`);
      setSettingsProxyUrl(payload.settings?.aiProxyUrl || "");
      setSettingsOpen(false);
      notify("Настройки сохранены");
    } catch (error) {
      notify(`Настройки не сохранены: ${String(error instanceof Error ? error.message : error)}`, "error");
    } finally {
      setSettingsSaving(false);
    }
  };

  return { settingsOpen, setSettingsOpen, settingsProxyUrl, setSettingsProxyUrl, settingsSaving, agentInstallCommand, setAgentInstallCommand, savePanelSettings };
}
